import { render, staticRenderFns } from "./TheCampaignCard.vue?vue&type=template&id=d80c9a10&scoped=true"
import script from "./TheCampaignCard.vue?vue&type=script&lang=js"
export * from "./TheCampaignCard.vue?vue&type=script&lang=js"
import style0 from "./TheCampaignCard.vue?vue&type=style&index=0&id=d80c9a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80c9a10",
  null
  
)

export default component.exports